import React, { createContext } from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider, createSelectorHook, createDispatchHook } from 'react-redux';
import createSagaMiddleware from 'redux-saga';

import reducer from './ValidarProcesso.store';
import watchValidarProcesso from './ValidarProcesso.saga';

export const ValidarProcessoContext = createContext();
export const useValidarProcessoSelector = createSelectorHook(ValidarProcessoContext);
export const useValidarProcessoDispatch = createDispatchHook(ValidarProcessoContext);

export default function ValidarProcessoProvider({ children }) {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(reducer, applyMiddleware(sagaMiddleware));
  sagaMiddleware.run(watchValidarProcesso);

  return (
    <Provider context={ValidarProcessoContext} store={store}>
      {children}
    </Provider>
  );
}
